import { render, staticRenderFns } from "./initTemplateManage.vue?vue&type=template&id=308a5a58&scoped=true&"
import script from "./initTemplateManage.vue?vue&type=script&lang=js&"
export * from "./initTemplateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a5a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308a5a58')) {
      api.createRecord('308a5a58', component.options)
    } else {
      api.reload('308a5a58', component.options)
    }
    module.hot.accept("./initTemplateManage.vue?vue&type=template&id=308a5a58&scoped=true&", function () {
      api.rerender('308a5a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/initTemplateManage.vue"
export default component.exports